module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_other_photo_pic.dd34fd2a.svg";